import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Link } from "@chakra-ui/react";
import React, { useMemo } from "react";

type Props = {
  link: string;
  author?: string;
};

const FeedLink = ({ link, author }: Props) => {
  const linkHref = useMemo(() => {
    if (!/^https?:\/\//.test(link)) return "https://" + link;
    return link;
  }, [link]);

  return (
    <Link href={linkHref} isExternal color="blue.300">
      {linkHref} <ExternalLinkIcon mx="2px" />
    </Link>
  );
};

export default FeedLink;
